import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import Price from 'common/price/Price';
import IconChevronDown from '@spothero/icons/chevron-down';
import TextButton from '@spothero/ui/text-button';

const ParkingRates = ({airportTitle, lowestDailyRate, onViewRatesClick}) => (
    <Card className="ParkingRates">
        <h2 className="ParkingRates-title">
            {airportTitle} Parking Rates{' '}
            {Boolean(lowestDailyRate) && (
                <>
                    Start at{' '}
                    <Price amount={lowestDailyRate} showCents={false} /> per Day
                </>
            )}
        </h2>
        <TextButton
            className="ParkingRates-view-rates"
            onClick={onViewRatesClick}
        >
            View {airportTitle} Parking Rates <IconChevronDown />
        </TextButton>
    </Card>
);

ParkingRates.propTypes = {
    airportTitle: PropTypes.string,
    lowestDailyRate: PropTypes.number,
    onViewRatesClick: PropTypes.func,
};

export default ParkingRates;
